import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError } from '@/lib/exception';
import { getClient } from '@/lib/restClient';
import { CustomField } from '@/pages/camel-order/sites/service';
import { SiteStatus } from '@/services/Site/hooks/list/useSiteList';
import { SiteService } from '@/services/Site/SiteService';

export type SiteUpdateParams = {
  logo_url: string;
  favicon_url: string | null;
  primary_color: string;
  faq_url: string | null;
  inquiry_url: string | null;
  term_url: string;
  sctl_url: string;
  privacy_url: string;
  title: string;
  description: string;
  status: SiteStatus;
  password: string;
  pay_type_settings: {
    setting_key: string;
    pay_types: string[];
  }[];
  site_banners: {
    image_url: string;
    link_url: string | null;
    sort_index: number;
  }[];
  google_tag_ids: string[];
  display_special_instruction: boolean;
  is_auth_available: boolean;
  use_three_d_secure2: boolean;
  gmo_shop: {
    name: string;
    name_kana: string;
    name_alphabet: string;
    name_short: string;
    contact_name: string;
    contact_email: string;
    contact_phone: string;
    contact_opening_hours: string;
    contact_closing_hours: string;
  } | null;
  order_methods: OrderMethod[];
  custom_order_method_text: {
    takeout: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
    eat_in: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
    delivery: {
      is_custom: boolean;
      text: string | null;
      button_text: string | null;
    };
  };
  custom_fields: CustomField[];
};

export const useSiteUpdate = async (
  id: string,
  params: SiteUpdateParams
): Promise<void> => {
  const siteService = new SiteService(getClient());
  try {
    const res = await siteService.update(id, params);
    return res;
  } catch (error) {
    if (error instanceof HttpError && error.status === 400) {
      alert(error.message);
      throw error;
    }
    // @ts-ignore TS2322
    errorHandler({ error });
  }
};
